import request from '@/utils/request'

export function findMenuTree(params) {
  return request({
    url: '/v1/systemMenu/findMenuTree',
    method: 'get',
    params
  })
}

export function findNavTree(params) {
  return request({
    url: '/v1/systemMenu/findNavTree',
    method: 'get',
    params
  })
}

export function saveOrUpdateMenu(data) {
  return request({
    url: '/v1/systemMenu/saveOrUpdate',
    method: 'post',
    data
  })
}

export function deleteMenu(data) {
  return request({
    url: '/v1/systemMenu/delete',
    method: 'delete',
    data
  })
}
